/* Eclora: sync ATC button + sticky bar prices with the selected Moon Bundle tier.
   Reads the public store exposed by Moon Bundle: window.MoonBundle[bundleId].currentOffer / .prices */
(function () {
  if (window.__ecloraMoonPrice) return;
  window.__ecloraMoonPrice = true;

  function render(bundle) {
    var offer = bundle.currentOffer.get();
    var prices = bundle.prices.get();
    if (!offer || !prices || !prices[offer.id]) return;
    var p = prices[offer.id];
    var now = p.totalDiscountedPriceFormatted;
    var was = p.totalOriginalPriceFormatted;
    var pct = p.totalOriginalPrice > 0 ? Math.round((p.totalOriginalPrice - p.totalDiscountedPrice) * 100 / p.totalOriginalPrice) : 0;

    document.querySelectorAll('[class*="main-atc-price-span-"]').forEach(function (el) { el.textContent = now; });
    document.querySelectorAll('.sticky-atc__price').forEach(function (box) {
      box.querySelectorAll('.price-item--sale, .price__regular .price-item--regular').forEach(function (el) { el.textContent = now; });
      box.querySelectorAll('.price__compare-price .price-item--regular').forEach(function (el) { el.textContent = was; });
      box.querySelectorAll('.badge__percentage-saved').forEach(function (el) { el.textContent = pct; });
    });
  }

  function hook() {
    var M = window.MoonBundle;
    if (!M) return false;
    var ids = Object.keys(M);
    if (!ids.length) return false;
    var bundle = M[ids[0]];
    if (!bundle || !bundle.currentOffer || !bundle.prices) return false;
    var update = function () { render(bundle); };
    bundle.currentOffer.subscribe(update);
    bundle.prices.subscribe(update);
    update();
    return true;
  }

  var tries = 0;
  (function wait() {
    if (hook()) return;
    if (++tries < 60) setTimeout(wait, 250);
  })();
})();
